import { useEffect } from "react";
import useFetchData from "../../../../common/api/useFetchData";

export function useLoadUtilisationSearchRangeData(
	endpoint,
	currentInput,
	onInputChange,
) {
	const { data, loading, error } = useFetchData({ endpoint });

	useEffect(() => {
		if (data && currentInput.isEmpty()) {
			const currentYear = new Date().getFullYear();
			const currentMonth = new Date().getMonth();
			onInputChange(
				currentInput.merge({
					from_year: currentYear - 2,
					from_month: currentMonth,
					to_year: currentYear + 1,
					to_month: currentMonth,
					check_avg_daily_ut: true,
					check_avg_st_length: true,
					check_cycles: true,
					check_hours: true,
					type: "historical_data",
					utilisation_data_historical: true,
					utilisation_data_type_1: true,
					utilisation_data_type_2: true,
					utilisation_data_type_aircraft: true,
				}),
				true,
			);
		}
	}, [data, currentInput]);

	return { data, loading, error };
}
